import React from 'react';
import { Check, Sparkles, ArrowRight } from 'lucide-react';

const HEADING = { fontFamily: "'Space Grotesk', system-ui, sans-serif" } as const;

const PLANS = [
  { name: 'Starter', description: 'Pour les petites équipes qui démarrent', price: '0', period: 'Gratuit', features: ["Jusqu'à 3 utilisateurs", 'Projets illimités', 'Vues Kanban & Liste', 'Tâches & sous-tâches', 'Support email'], cta: 'Commencer gratuitement', popular: false },
  { name: 'Pro', description: 'Pour les équipes qui veulent piloter', price: '12', period: '/utilisateur/mois', features: ['Utilisateurs illimités', 'Toutes les vues (Gantt, Calendrier…)', 'Charge & capacité équipe', 'Feuilles de temps', 'Budget projet', 'Intégrations', 'Support prioritaire'], cta: 'Essai gratuit 14 jours', popular: true },
  { name: 'Business', description: 'Pour les workspaces exigeants', price: '24', period: '/utilisateur/mois', features: ['Tout le plan Pro', 'SSO / SAML', 'Rôles & permissions avancés', 'Audit logs', 'API complète', 'SLA garanti', 'Account manager dédié'], cta: 'Contacter les ventes', popular: false },
];

export function PricingSection() {
  return (
    <section id="pricing" className="py-24 md:py-32 bg-[#0a0a1a] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#1e1e5a] text-[#a5b4fc] text-xs font-bold uppercase tracking-widest mb-6 border border-[#4f46e5]/30">
            <Sparkles className="h-3.5 w-3.5" />
            Tarifs
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 tracking-tighter" style={HEADING}>
            Simple et transparent
          </h2>
          <p className="text-lg text-slate-400">Choisissez le plan adapté à votre équipe. Évoluez à votre rythme.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {PLANS.map((plan) => (
            <div
              key={plan.name}
              className={`relative p-8 rounded-[2rem] border transition-all duration-300 flex flex-col ${
                plan.popular
                  ? 'bg-gradient-to-b from-[#1e1e5a] to-[#141432] border-[#4f46e5]/50 shadow-[0_20px_60px_-20px_rgba(79,70,229,0.5)] md:scale-105 z-10'
                  : 'bg-[#141432] border-[#1e1e5a] hover:border-[#4f46e5]/40'
              }`}
            >
              {plan.popular && (
                <div className="absolute -top-3 left-1/2 -translate-x-1/2">
                  <span className="px-4 py-1 rounded-full bg-[#4f46e5] text-white text-xs font-bold uppercase tracking-widest shadow-[0_0_24px_rgba(79,70,229,0.6)]">
                    Recommandé
                  </span>
                </div>
              )}
              <div className="mb-6">
                <h3 className="text-xl font-bold text-white mb-1" style={HEADING}>{plan.name}</h3>
                <p className="text-sm text-slate-400">{plan.description}</p>
              </div>
              <div className="mb-6">
                <div className="flex items-baseline gap-1">
                  <span className="text-5xl font-bold text-white tabular-nums" style={HEADING}>{plan.price}€</span>
                  <span className="text-slate-400">{plan.period}</span>
                </div>
              </div>
              <ul className="space-y-3 mb-8 flex-1">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-3">
                    <Check className="h-5 w-5 mt-0.5 shrink-0 text-[#a5b4fc]" />
                    <span className="text-slate-300 text-sm">{feature}</span>
                  </li>
                ))}
              </ul>
              <a
                href="https://app.lapyno.com/auth?mode=signup"
                className={`w-full inline-flex items-center justify-center gap-2 px-5 py-3 rounded-2xl font-bold text-sm transition-all ${
                  plan.popular
                    ? 'bg-[#4f46e5] hover:bg-[#4338ca] text-white shadow-[0_10px_30px_-10px_rgba(79,70,229,0.6)]'
                    : 'bg-[#1e1e5a] hover:bg-[#1e1e5a]/80 text-white border border-white/10'
                }`}
              >
                {plan.cta}
                <ArrowRight className="h-4 w-4" />
              </a>
            </div>
          ))}
        </div>

        <p className="text-center text-sm text-slate-500 mt-8">
          Tous les prix sont HT. Paiement mensuel ou annuel (-20%).
        </p>
      </div>
    </section>
  );
}
